import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Wrapper,
  Button,
  Row,
  Title,
  Copy,
  Card,
  Icon,
  Bold
} from "app/NativeComponents/common";
import { PillButton } from "app/NativeComponents/snippets";

import { getTeamFilters, appRedirect, setPresetModal } from "app/NativeActions";

import PresetItem from "../PresetItem";

class CustomPresets extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show_presets: !props.include_toggle ? true : false
    };

    this.handleShowMorePresetsPress = this.handleShowMorePresetsPress.bind(
      this
    );
  }

  componentDidMount() {
    if (
      this.props.team_filters.length === 0 &&
      !this.props.team_filters_loading
    ) {
      this.props.getTeamFilters({ token: this.props.token });
    }
  }

  renderPresets() {
    if (this.state.show_presets == true) {
      return (
        <Row style={{ flexWrap: "wrap", overflow: "visible" }}>
          {this.props.team_filters.map((preset, i) => {
            return (
              <PresetItem
                key={i}
                {...this.props}
                onPress={this.props.onPress}
                is_active={this.props.active_preset == preset.id ? true : false}
                preset={preset}
                title={preset.title}
                show_options={
                  this.props.active_preset == preset.id ? true : false
                }
                onEdit={() => {
                  this.props.setPresetModal({
                    type: "edit",
                    preset_id: preset.id,
                    filters: preset.filter_json,
                    use_for_dealfinders: preset.use_for_dealfinders,
                    preset_title: preset.title
                  });
                  this.props.appRedirect({
                    redirect: "goForward",
                    payload: { add: "preset" }
                  });
                }}
              />
            );
          })}
        </Row>
      );
    }
  }

  handleShowMorePresetsPress() {
    this.setState({
      show_presets: !this.state.show_presets
    });
  }

  renderShowMoreButton() {
    const { show_presets } = this.state;
    if (this.props.include_toggle) {
      return (
        <Button
          onPress={this.handleShowMorePresetsPress}
          style={{ marginBottom: 10 }}
        >
          <Row>
            <Copy>
              <Bold>{show_presets ? "Hide Presets" : "Show Presets"}</Bold>
            </Copy>
            <Icon
              style={{ marginLeft: 5 }}
              size={18}
              icon={show_presets ? "keyboard-arrow-up" : "keyboard-arrow-down"}
            />
          </Row>
        </Button>
      );
    }
  }

  render() {
    const { show_presets } = this.state;
    if (this.props.team_filters && this.props.team_filters.length > 0) {
      return (
        <Wrapper
          style={{
            padding: 20,
            paddingBottom: 0,
            paddingLeft: 10,
            paddingRight: 10
          }}
        >
          <Wrapper>
            <Copy style={{ marginBottom: 10 }}>{this.props.title}</Copy>
            {this.renderShowMoreButton()}
          </Wrapper>
          {this.renderPresets()}
        </Wrapper>
      );
    }
    return null;
  }
}

const mapStateToProps = ({ auth, settings, native, filter }) => {
  const { token, user } = auth;
  const { device, platform, isMobile } = native;
  const { colors } = settings;
  const { team_filters } = filter;
  return {
    token,
    user,
    device,
    platform,
    isMobile,
    colors,
    team_filters
  };
};

export default connect(mapStateToProps, {
  getTeamFilters,
  appRedirect,
  setPresetModal
})(CustomPresets);
